"use client";

import type { ReactNode } from "react";
import { WEB_PAGE_SURFACE_MD_CLASS } from "@/components/layout/WebPageSurface";
import { PageLayout } from "@/components/layout";
import { cn } from "@/lib/utils";

export const AUTH_PRIMARY_BUTTON_CLASS =
  "w-full flex h-[52px] rounded-lg text-lg font-medium border-2 border-black shadow-[0_4px_0_0_black] active:shadow-none transition-all duration-150 items-center justify-center active:translate-y-[4px]";

export const AUTH_SECONDARY_BUTTON_CLASS =
  "bg-white border-2 border-black rounded-lg h-[48px] shadow-[0_4px_0_0_black] flex items-center justify-center gap-2 transition-all duration-150 w-full active:translate-y-[4px] active:shadow-none";

export const AUTH_ICON_BUTTON_CLASS =
  "bg-white border-2 border-black flex flex-[1_0_0] h-[44px] items-center justify-center rounded-lg shadow-[0px_4px_0px_0px_black] transition-transform active:translate-y-[4px] active:shadow-none";

interface AuthResponsivePageProps {
  hero: ReactNode;
  children: ReactNode;
  className?: string;
  heroClassName?: string;
  contentClassName?: string;
}

export function AuthResponsivePage({
  hero,
  children,
  className,
  heroClassName,
  contentClassName,
}: AuthResponsivePageProps) {
  return (
    <PageLayout responsive={true}>
      <main className={cn("w-full md:px-8 md:py-8", className)}>
        <div
          data-testid="auth-responsive-surface"
          className={cn(
            "mx-auto flex w-full flex-col md:max-w-3xl md:items-stretch md:space-y-6 md:px-8 md:py-8 md:text-left",
            WEB_PAGE_SURFACE_MD_CLASS,
          )}
        >
          <div
            className={cn(
              "w-full mt-4 shrink-0 md:px-0 md:mt-0",
              heroClassName,
            )}
          >
            {hero}
          </div>

          <div
            className={cn(
              "mt-5 flex flex-1 flex-col justify-start px-5 md:mt-0 md:space-y-4 md:px-0",
              contentClassName,
            )}
          >
            {children}
          </div>
        </div>
      </main>
    </PageLayout>
  );
}
